import { ButtonHTMLType } from 'antd/lib/button/button'
import * as React from 'react'

import { Anchor, Button } from './DefaultButton.style'

interface DefaultButtonProps {
  children?: React.ReactNode
  rounded?: boolean
  backgroundColor?: string
  borderColor?: string
  hoverBackground?: string
  hoverColor?: string
  hoverBorder?: string
  buttonHeight?: string
  fullWidth?: boolean
  padding?: string
  disabled?: boolean
  noWrap?: boolean
  color?: string
  fontWeight?: string
  style?: React.CSSProperties
  fontSize?: string
  type?: ButtonHTMLType
  onClick?: (e) => void
  isExternal?: boolean
  href?: string
}

const DefaultButton: React.FC<DefaultButtonProps> = ({
  children,
  rounded,
  backgroundColor,
  borderColor,
  hoverBackground,
  hoverColor,
  hoverBorder,
  buttonHeight,
  fullWidth,
  onClick,
  padding,
  disabled,
  noWrap,
  color,
  fontWeight,
  style,
  fontSize,
  type,
  isExternal,
  href,
}) => {
  return isExternal ? (
    <Anchor
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      noWrap={noWrap}
      rounded={rounded}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      hoverBackground={hoverBackground}
      hoverColor={hoverColor}
      hoverBorder={hoverBorder}
      buttonHeight={buttonHeight}
      fullWidth={fullWidth}
      padding={padding}
      onClick={onClick}
      disabled={disabled}
      color={color}
      fontWeight={fontWeight}
      style={style}
      fontSize={fontSize}
      type={type}
    >
      {children}
    </Anchor>
  ) : (
    <Button
      noWrap={noWrap}
      rounded={rounded}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      hoverBackground={hoverBackground}
      hoverColor={hoverColor}
      hoverBorder={hoverBorder}
      buttonHeight={buttonHeight}
      fullWidth={fullWidth}
      padding={padding}
      onClick={onClick}
      disabled={disabled}
      color={color}
      fontWeight={fontWeight}
      style={style}
      fontSize={fontSize}
      type={type}
    >
      <span>{children && children}</span>
    </Button>
  )
}

export default React.memo(DefaultButton)



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/DefaultButton/DefaultButton.tsx